import { useState } from 'react';
import monsters from '../../data/monsters.json'
import artaleMonsters from '../../data/artaleMonsters.json'
import flyingMonsters from '../../data/flyingMonsters.json'
import standingMonsters from '../../data/standingMonsters.json'
import monsterCustomImages from '../../data/monsterCustomImagePaths.json'

function MonsterDetails({
    damageType,
    characterLevel,
    characterStats
}) {
    const [dataSource, setdataSource] = useState(monsters);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredMonsters, setFilteredMonsters] = useState(dataSource);

    const monstersByLevel = filteredMonsters.sort(function (a, b) {
        return a.level - b.level
    });

    const handleDataSourceChange = (value) => {
        if (value == 'soup') {
            setdataSource([]);
            setdataSource(monsters);
            setFilteredMonsters(monsters);
            setSearchTerm('');
        }
        else if (value == 'artale') {
            setdataSource([]);
            setdataSource(artaleMonsters);
            setFilteredMonsters(artaleMonsters);
            setSearchTerm('');
        }
    }

    const handleSearchChange = (event) => {
        const newSearchTerm = event.target.value;

        setSearchTerm(newSearchTerm);

        let filtered = []

        if (newSearchTerm === null || newSearchTerm.trim() === '') {
            filtered = dataSource;
        }
        else {
            filtered = dataSource.filter((monster) => {
                return monster.name.toLowerCase().includes(searchTerm.toLowerCase());
            })
        }

        setFilteredMonsters(filtered);
    }

    function GetLevelDiff(monsterLevel) {
        const monsterLevelInt = parseInt(monsterLevel);
        const characterLevelInt = parseInt(characterLevel);

        let levelDiff = monsterLevelInt - characterLevelInt;

        if (levelDiff < 0) {
            levelDiff = 0;
        }

        return levelDiff
    };

    function GetOneHundredPercentHit(monsterAvoid, monsterLevel) {
        const monsterAvoidInt = parseInt(monsterAvoid);
        const levelDiff = GetLevelDiff(monsterLevel);

        // 100% accuracy calculation here
        if (damageType === 'p') {
            return (55.2 + 2.15 * levelDiff) * (monsterAvoidInt / 15);
        }

        return Math.floor((monsterAvoidInt + 1.0) * (1.0 + (0.04 * levelDiff)));
    };

    function GetMonsterOnePercentHit(monsterAvoid, monsterLevel) {
        const oneHundredPercentAcc = GetOneHundredPercentHit(monsterAvoid, monsterLevel)

        // 1% accuracy calculation here
        if (damageType === 'p') {
            return oneHundredPercentAcc * 0.5 + 1;
        }

        return Math.round(0.41 * oneHundredPercentAcc);
    };

    function GetHitRate(monsterAvoid, monsterLevel) {
        let hitRate = 0;

        const oneHundredPercentAcc = GetOneHundredPercentHit(monsterAvoid, monsterLevel);
        const onePercentAcc = GetMonsterOnePercentHit(monsterAvoid, monsterLevel);

        if (damageType === 'p') {
            const charStatAccInt = parseInt(characterStats.acc);

            hitRate = 100 * ((charStatAccInt - (oneHundredPercentAcc * 0.5)) / (oneHundredPercentAcc * 0.5));
        }
        else {
            const charStatIntInt = parseInt(characterStats.int);
            const charStatLukInt = parseInt(characterStats.luk);

            let currentAccuracy = (Math.floor(charStatIntInt / 10) + Math.floor(charStatLukInt / 10));
            console.debug('Current acc is:', currentAccuracy);
            
            // Should test this a bit - this is using the same calc for phys we just use the magic calc for acc...
            // hitRate = 100 * ((currentAccuracy - (oneHundredPercentAcc * 0.5)) / (oneHundredPercentAcc * 0.5));
            
            let accuracyPartial = (currentAccuracy - onePercentAcc + 1) / (oneHundredPercentAcc - onePercentAcc + 1);
            console.debug('Acc partial is:', accuracyPartial);

            hitRate = ((-0.7011618132 * Math.pow(accuracyPartial, 2)) + (1.702139835 * accuracyPartial)) * 100;
            console.debug('Calculated hit rate is:', hitRate);
        }

        if (hitRate > 100) {
            hitRate = 100;
            console.debug('Hit rate was above 100, hit rate is now:', hitRate);
        }
        else if (hitRate < 0) {
            hitRate = 0;
            console.debug('Hit rate was below 0, hit rate is now:', hitRate);
        }

        console.debug('returning hit rate of:', hitRate);
        return hitRate;
    };

    function GetBackgroundColor(monsterAvoid, monsterLevel) {
        const hitRate = GetHitRate(monsterAvoid, monsterLevel);

        if (hitRate == 100) {
            return 'rgba(35, 255, 0, 0.75)';
        }
        else if (hitRate < 100 && hitRate >= 60) {
            return 'rgba(250, 255, 88, 0.75)';
        }
        else if (hitRate < 60 && hitRate >= 30) {
            return 'rgba(255, 146, 0, 0.75)';
        }
        else if (hitRate < 30 && hitRate >= 1) {
            return 'rgba(255, 0, 0, 0.75)';
        }
        else {
            return 'rgba(206, 206, 206, 0.75)';
        }
    }

    return (
        <div>
            <div className='p-1' style={{
                textAlign: '-webkit-center'
            }}>
                <strong>Monster Data Source: </strong>
                <div>
                    <button type="button" className="btn btn-outline-primary m-1" onClick={(event) => { handleDataSourceChange('soup') }}>MrSoupMan Calc</button>
                    <button type="button" className="btn btn-outline-primary m-1" onClick={(event) => { handleDataSourceChange('artale') }}>Artale</button>
                </div>
            </div>

            <div className='p-1' style={{
                textAlign: '-webkit-center'
            }}>
                <strong>Monster Search: </strong>
                <input className='form-control' style={{ width: '25%', textAlign: 'center' }} type='text' value={searchTerm} onChange={handleSearchChange} />
            </div>

            <div className="row">
                {monstersByLevel.map(monster => {
                    let renderType = 'move'

                    if (flyingMonsters.includes(monster.id)) {
                        renderType = 'fly'
                    }
                    else if (standingMonsters.includes(monster.id)) {
                        renderType = 'stand'
                    }

                    let imgSource = `https://maplestory.io/api/gms/62/mob/${monster.id}/render/${renderType}`;

                    if (monsterCustomImages.some(customImage => customImage.id === monster.id)) {
                        imgSource = monsterCustomImages.find(customImage => customImage.id === monster.id).img;
                    }

                    return (<div key={monster.id} className="col-2"
                        style={{
                        }}>
                        <div className="col-12" style={{
                            marginTop: '24px',
                            backgroundColor: `${GetBackgroundColor(monster.avoid, monster.level)}`,
                            borderRadius: '10px',
                            boxShadow: 'rgba(136, 165, 191, 1) 6px 2px 16px 0px, rgba(255, 255, 255, 0.8) -6px -2px 16px 0px'
                        }}>
                            <div>
                                <img src={imgSource} width={50} height={50} />
                            </div>
                            <div>
                                <strong>{monster.name}</strong>
                            </div>
                            <div>
                                <span>Level: {monster.level}</span>
                            </div>
                            <div>
                                <span>Avoid: {monster.avoid}</span>
                            </div>
                            <div>
                                <span>Acc for 1% Hit: <strong>{GetMonsterOnePercentHit(monster.avoid, monster.level).toPrecision(3)}</strong></span>
                            </div>
                            <div>
                                <span>Acc for 100% Hit: <strong>{GetOneHundredPercentHit(monster.avoid, monster.level).toPrecision(3)}</strong></span>
                            </div>
                            <div>
                                <span>Hit Rate: <strong>{GetHitRate(monster.avoid, monster.level).toPrecision(3)}</strong></span>
                            </div>
                        </div>
                    </div>)
                })}
            </div>
        </div>
    )
}

export default MonsterDetails